import createApiClient from "./api";

const api = createApiClient();

export const createDrawing = async (
  projectId,
  drawingFolderId,
  drawingData
) => {
  const formData = new FormData();

  // Add required fields to form data
  formData.append("title", drawingData.title);
  formData.append("drawing_number", drawingData.drawing_number);
  formData.append("revision_date", drawingData.revision_date);
  formData.append("revision_title", drawingData.revision_title);
  formData.append("file", drawingData.file);

  const response = await api.post(
    `/projects/${projectId}/drawings?drawing_folder_id=${drawingFolderId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

export const createDrawingsBulkAI = async (projectId, drawingFolderId, files) => {
  const formData = new FormData();

  // Append every selected file under the same "files" field (List[UploadFile])
  files.forEach((file) => {
    formData.append("files", file);
  });

  const response = await api.post(
    `/projects/${projectId}/drawings/ai?drawing_folder_id=${drawingFolderId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

export const fetchDrawings = async (
  projectId,
  drawingFolderId,
  params = {}
) => {
  const response = await api.get(`/projects/${projectId}/drawings`, {
    params: {
      drawing_folder_id: drawingFolderId,
      skip: params.skip || 0,
      limit: params.limit || 10,
      filters: params.filters || null,
      show_latest_revisions_only: params.show_latest_revisions_only !== undefined ? params.show_latest_revisions_only : true,
      sort_field: params.sort_field || null,
      sort_order: params.sort_order || undefined,
      include_annotations:
        params.include_annotations !== undefined ? params.include_annotations : true,
    },
    headers: {},
  });
  return response.data;
};

export const searchDrawings = async (projectId, q = "", params = {}) => {
  const response = await api.get(`/projects/${projectId}/drawings/search`, {
    params: {
      q: q || "",
      skip: params.skip || 0,
      limit: params.limit || 50,
      drawing_folder_id: params.drawingFolderId || params.drawing_folder_id || undefined,
    },
    headers: {},
  });
  return response.data;
};

export const fetchLatestDrawingRevision = async (projectId, drawingNumber, drawingFolderId) => {
  const response = await api.get(`/projects/${projectId}/drawings/latest-revision`, {
    params: {
      drawing_number: drawingNumber,
      drawing_folder_id: drawingFolderId,
    },
    headers: {},
  });
  return response.data;
};

export const detectSheetLinks = async (projectId, drawingId, page = 0) => {
  const response = await api.post(
    `/projects/${projectId}/drawings/${drawingId}/sheet-links`,
    {},
    {
      params: { page: page || 0 },
      timeout: 120000,
      headers: {},
    }
  );
  return response.data;
};

export const fetchDrawing = async (projectId, drawingId) => {
  const response = await api.get(
    `/projects/${projectId}/drawings/${drawingId}`,
    {
      headers: {},
    }
  );
  return response.data;
};

export const updateDrawing = async (projectId, drawingId, drawingData) => {

  // Only send allowed fields in update
  const updateData = {
    title: drawingData.title,
    drawing_number: drawingData.drawing_number,
    revision_date: drawingData.revision_date
      ? new Date(drawingData.revision_date).toISOString().split("T")[0]
      : null,
    revision_title: drawingData.revision_title,
    annotations: drawingData?.annotations,
  };

  const response = await api.put(
    `/projects/${projectId}/drawings/${drawingId}`,
    updateData,
    { headers: {} }
  );
  return response.data;
};

export const moveDrawing = async (projectId, drawingId, drawingFolderId) => {
  const response = await api.patch(
    `/projects/${projectId}/drawings/${drawingId}/move`,
    { drawing_folder_id: drawingFolderId },
    { headers: {} }
  );
  return response.data;
};

export const deleteDrawing = async (projectId, drawingId) => {
  const response = await api.delete(
    `/projects/${projectId}/drawings/${drawingId}`,
    { headers: {} }
  );
  return response.data;
};
